var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import Session from '../../services/Session';
import History from '../../services/History';
import resetPassword from '../../requests/authentication/resetPassword';
import Signals from '../../signals/Signals';
/**
 *
 */
var ResetPasswordCommand = /** @class */ (function (_super) {
    __extends(ResetPasswordCommand, _super);
    function ResetPasswordCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param resetToken
     * @param password
     * @param intl
     */
    ResetPasswordCommand.prototype.execute = function (resetToken, password, intl) {
        this.intl = intl;
        //
        var promise = resetPassword({ resetPasswordToken: resetToken, newPassword: password });
        promise.then(this.then);
        promise.catch(this.catch);
        return promise;
    };
    /**
     *
     * @param response
     */
    ResetPasswordCommand.prototype.then = function (response) {
        Signals.ShowNotification.dispatch(this.intl.formatMessage({ id: 'notification.password.changed' }), 'dark', true);
        Session.setJWT(response);
        History.push('/');
    };
    ResetPasswordCommand.prototype.catch = function (error) {
        Signals.ShowNotification.dispatch(this.intl.formatMessage({ id: 'notification.password.changed.failed' }), 'dark', true);
        History.push('/');
    };
    return ResetPasswordCommand;
}(Command));
export default ResetPasswordCommand;
